import { render } from "./ProductBlockchain.vue?vue&type=template&id=443a4972&scoped=true"
import script from "./ProductBlockchain.vue?vue&type=script&lang=js"
export * from "./ProductBlockchain.vue?vue&type=script&lang=js"

import "./ProductBlockchain.vue?vue&type=style&index=0&id=443a4972&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443a4972"]])

export default __exports__